<template>
  <div class="" ref="setH">
    <div class="manageBox">
      <div class="shrink">
        <div class="bg1" :class="shrink ? '' : 'on'" style="min-height: 0px">
          <div class="shrinkRight">
            <el-button
              type="primary"
              @click="
                shrink = true;
                getSongYinJiLu();
              "
              size="small"
              style="margin-left: 74px"
              >查询</el-button
            >
            <el-button @click="clear" size="small">重置</el-button>
            <el-button
              size="small"
              :icon="shrink ? 'el-icon-arrow-left' : 'el-icon-arrow-down'"
              class="shrinkButton"
              @click="shrink = !shrink"
            ></el-button>
          </div>
          <div class="searchBox">
            <ul>
              <li>
                <em>资源名称：</em>
                <el-input
                  v-model="search.resourceName"
                  size="small"
                  style="width: 250px"
                  placeholder="请输入内容"
                ></el-input>
              </li>
              <li>
                <em>文件类型：</em>
                <div style="display: inline-block; width: 830px">
                  <el-radio-group v-model="search.fileType" size="small">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button
                      v-for="(item, i) in conditions.wendangleixingList"
                      :key="'resource' + i"
                      :label="item.key"
                      >{{ item.value }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </li>
              <li>
                <em>资源类型：</em>
                <div style="display: inline-block; width: 830px">
                  <el-radio-group v-model="search.resourceTypeId" size="small">
                    <el-radio-button label="">全部</el-radio-button>
                    <el-radio-button
                      v-for="(item, i) in conditions.ziyuanleibieList"
                      :key="'resource' + i"
                      :label="item.code"
                      >{{ item.name }}</el-radio-button
                    >
                  </el-radio-group>
                </div>
              </li>
              <li>
                <em>选择时间：</em>
                <el-date-picker
                  v-model="search.startTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 140px"
                  size="small"
                  :picker-options="startDatePicker"
                  :placeholder="'请选择开始时间'"
                ></el-date-picker>
                -
                <el-date-picker
                  v-model="search.endTime"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 140px"
                  size="small"
                  :picker-options="endDatePicker"
                  :placeholder="'请选择结束时间'"
                ></el-date-picker>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="bg1">
        <div class="contentBox">
          <div class="bd ys4" style="min-height: 520px">
            <ul v-if="tableData.length > 0">
              <li
                v-for="(d, i) in tableData"
                :key="i"
                style="height: auto; overflow: hidden"
              >
                <div class="icon">
                  <svg class="icon" aria-hidden="true">
                    <use :xlink:href="'#icontbd' + d.fileType"></use>
                  </svg>
                  <em v-if="d.fileType == 1 || d.fileType == 2 || d.fileType == 3"
                    >- {{ d.filePage }}页 -</em
                  >
                </div>
                <div class="title">
                  <h5 @click="yulan(d, 1)">{{ d.resourceName }}</h5>
                  <span class="catalog">
                    <i class="ka">{{ d.resourceTypeName }}</i>
                    <i v-if="d.versionName">{{ d.versionName }}</i>
                    <i v-if="d.volumeName">/{{ d.volumeName }}</i>
                    <i v-if="d.firstChapterName">/{{ d.firstChapterName }}</i>
                    <i v-if="d.secondChapterName">/{{ d.secondChapterName }}</i>
                    <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                    <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i>
                  </span>
                  <span class="attribute">份数：{{ d.printNumber }}</span>
                  <span class="attribute">方式：{{ d.printTypeName }}</span>
                  <span class="attribute">纸张类型：{{ d.paperTypeName }}</span>
                  <span class="attribute"
                    >打印状态：
                    <em :class="d.printStateName == '已打印' ? 'blue' : 'red'">{{
                      d.printStateName
                    }}</em></span
                  >
                  <span class="attribute"
                    >送印时间：{{ d.createTime.split(" ")[0] }}</span
                  >
                  <!-- <span class="school">学校：{{ d.schoolName }}</span>
                <span class="author">作者：{{ d.createUserName }}</span> -->
                </div>
                <div class="operate">
                  <el-button type="primary" @click="songyin(d)" size="small"
                    >送印</el-button
                  >
                  <el-button type="text" @click="cancel(d)" size="small"
                    >取消送印</el-button
                  >
                  <el-button
                    v-if="d.printState == 0"
                    type="text"
                    @click="bianji(d)"
                    size="small"
                    >编辑</el-button
                  >
                  <el-button type="text" @click="beizhu(d)" size="small"
                    >查看备注</el-button
                  >
                </div>
              </li>
            </ul>
            <div class="unusual" v-else>
              <span class="pt320">暂无内容</span>
            </div>
            <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="pages.pageAll"
              :page-size="pages.pageSize"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
      <el-form :model="form" label-width="100px">
        <el-form-item label="方式">
          <el-radio-group v-model="form.printType">
            <el-radio :label="1">单面打印</el-radio>
            <el-radio :label="2">双面打印</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number
            v-model="form.printNumber"
            :step="1"
            :min="1"
            label="份"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="纸张类型">
          <el-radio-group v-model="form.paperType">
            <el-radio
              :label="paperType.key"
              :key="i"
              v-for="(paperType, i) in conditions.paperTypeList"
              >{{ paperType.value }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            maxlength="100"
            show-word-limit
            :rows="5"
            placeholder="请输入内容"
            v-model="form.remark"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="tijiaosongyin" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="备注" :visible.sync="bezhuShow">
      <el-input
        type="textarea"
        :rows="5"
        maxlength="100"
        show-word-limit
        placeholder="请输入内容"
        v-model="remarkCon"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bezhuShow = false" size="small">取 消</el-button>
        <el-button type="primary" @click="tianjiabeizhu" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <!-- <yulan :watchType='watchType' :fileUrl='fileUrl' @watch-type="getWatchType"></yulan> -->
  </div>
</template>

<script>
import yulan from "@/components/yulan";
import yulanmix from "../../mixins/yulan";
export default {
  name: "printing",
  data() {
    return {
      dialogFormVisible: false,
      search: {
        approvalState: 1,
        approvalSchoolId: "",
        sectionId: "",
        subjectId: "",
        versionId: "",
        gradeId: "",
        volumeId: "",
        relationDataId: "",
        dataId: "",
        chapterId: "",
        resourceTypeId: "",
        fileType: "",
        resourceName: "",
        firstChapterId: "",
        secondChapterId: "",
        thirdChapterId: "",
        fourthChapterId: "",
        startTime: "",
        endTime: "",
        page: 1,
        size: 10,
      },
      conditions: {
        xuexiaoList: [],
        xueduanList: [],
        nianjiList: [],
        xuekeList: [],
        banbenList: [],
        ceciList: [],
        zhangjieList: [],
        ziyuanleibieList: [],
        wendangleixingList: [],
        paperTypeList: [],
      },
      tableData: [],
      dialogTitle: "",
      dialogType: 1,
      bezhuShow: false,
      remarkCon: "",
      rid: "",
      form: {
        id: "",
        resourceId: "",
        printType: 1,
        printNumber: 0,
        remark: "",
        paperType: "",
      },
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      tabH: 0,
      watchType: null,
      fileUrl: "",
      uploadUrl: "",
      previewUrl: "",
      shrink: true,
      startDatePicker: {
        disabledDate: (time) => {
          if (this.search.endTime) {
            return time.getTime() > new Date(this.search.endTime).getTime();
          }
        },
      },
      endDatePicker: {
        disabledDate: (time) => {
          if (this.search.startTime) {
            return time.getTime() < new Date(this.search.startTime).getTime() - 86400000;
          }
        },
      },
    };
  },
  components: { yulan },
  mixins: [yulanmix],
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 150;
    });
    this.getZiYuanLeiBie();
    this.getWenDangLeixing();
    this.getSongYinJiLu();
    this.getPaperType();
    this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
    this.previewUrl = window.sessionStorage.getItem("previewUrl");
  },
  methods: {
    getPaperType() {
      this.$ajax.post("/common/load/paper/type").then((res) => {
        this.conditions.paperTypeList = res;
        this.form.paperType = 1;
      });
    },
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    // // 预览点击
    // yulan(obg){
    //   if(obg.fileType<4){
    //     this.fileUrl = window.sessionStorage.getItem("previewUrl") + window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else if(obg.fileType==4){
    //     this.fileUrl =  window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else if(obg.fileType==5){
    //     this.fileUrl =  window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else{

    //   }
    // },
    // // 获取子节点返回的查看值
    // getWatchType(event){
    //   console.log(event);
    //   this.watchType = event;
    // },
    //清空查询条件
    clear() {
      this.search.resourceTypeId = "";
      this.search.fileType = "";
      this.search.resourceName = "";
      this.search.startTime = "";
      this.search.endTime = "";
      this.search.paperType = "";
    },
    // 获取资源类别
    getZiYuanLeiBie() {
      let urlLink = `/common/load/resource/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取资源类别", res);
        this.conditions.ziyuanleibieList = res;
      });
    },
    // 获取文档类型
    getWenDangLeixing() {
      let urlLink = `/common/load/file/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取文档类型", res);
        this.conditions.wendangleixingList = res;
      });
    },
    // 获取送印记录
    getSongYinJiLu() {
      let urlLink = `/server/my/record/print/getRecordPrintList`;
      this.$ajax.post(urlLink, this.search).then((res) => {
        console.log("获取送印记录", res);
        // this.conditions.wendangleixingList = res;
        this.tableData = res.list;
        this.pages.pageAll = res.total;
      });
    },
    // 分页页码变动
    handleSizeChange() {
      this.search.size = v;
      this.search.page = 1;
      this.getSongYinJiLu();
    },
    handleCurrentChange(v) {
      this.search.page = v;
      this.getSongYinJiLu();
    },
    // 送印
    songyin(obg) {
      this.dialogFormVisible = true;
      this.form.resourceId = obg.resourceId;
      this.id = "";
      this.dialogType = 1;
      this.form.printType = 2;
      this.form.printNumber = "";
      this.form.remark = "";
    },
    cancel(obg) {
      this.$confirm("请确认是否取消送印?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$ajax
            .post("/server/my/record/print/cancelPrint", { id: obg.id })
            .then((res) => {
              this.getSongYinJiLu();
              this.$message.success("取消成功");
            });
        })
        .catch(() => {});
    },
    // 编辑
    bianji(obg) {
      this.dialogFormVisible = true;
      this.dialogTitle = "资料送印编辑";
      this.dialogType = 2;
      this.form = obg;
      this.form.paperType = parseInt(obg.paperType);
    },
    // 备注
    beizhu(obg) {
      this.bezhuShow = true;
      this.remarkCon = obg.remark;
      this.rid = obg.id;
    },
    // 添加备注
    tianjiabeizhu() {
      let urlLink = `/server/my/record/print/updateRemark`;
      let param = { id: this.rid, remark: this.remarkCon };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("修改添加备注返回", res);
        if (res == "操作成功") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.bezhuShow = false;
          this.getSongYinJiLu();
        }
      });
    },
    // 提交送印
    tijiaosongyin() {
      let urlLink =
        this.dialogType == 1
          ? `/server/my/record/print/printResourceById`
          : `/server/my/record/print/editResourceById`;
      this.$ajax.post(urlLink, this.form).then((res) => {
        if (res == "操作成功") {
          this.$message({
            message: "送印成功",
            type: "success",
          });
          this.dialogFormVisible = false;
          this.getSongYinJiLu();
        }
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/page/my/printing.vue